import type { MutationObserverOptions } from '@tanstack/vue-query';
import { useMutation } from '@tanstack/vue-query';
import { ref } from 'vue';
import { MyDocumentsService } from '../service/my-documents.service';

export const useMyDocumentsValidateEmail = (
  options?: MutationObserverOptions<boolean, unknown, unknown, unknown>
) => {
  const isInvalidCode = ref(false);

  const mutation = useMutation({
    ...options,
    mutationFn: (code: number) => MyDocumentsService.verifyEmail(code),
    onSuccess: (data, variables, context) => {
      if (options?.onSuccess) {
        options?.onSuccess(data, variables, context);
      }
    },
    onError: ({ message }, variables, context) => {
      isInvalidCode.value = message.includes('Email verification failed');
      if (options?.onError) {
        options?.onError(message, variables, context);
      }
    },
  });

  return { ...mutation, isInvalidCode };
};
